import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function ViewInvoice() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [invoice,
    setInvoice] =
    useState(null);

  const [items,
    setItems] =
    useState([]);

  useEffect(() => {
    loadInvoice();
  }, []);

  const loadInvoice =
    async () => {

      try {

        const res =
          await API.get(
            `/invoices/${id}`
          );

        setInvoice(
          res.data.invoice
        );

        setItems(
          res.data.items || []
        );

      } catch (err) {
        console.log(err);
      }

    };

  const printInvoice =
    () => {
      window.print();
    };

  if (!invoice) {
    return (
      <div>
        Loading...
      </div>
    );
  }

  return (
    <div>

      <style>
        {`
          @media print {

            body * {
              visibility: hidden;
            }

            #invoice-print,
            #invoice-print * {
              visibility: visible;
            }

            #invoice-print {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              background: white !important;
              color: black !important;
              padding: 20px;
            }

            .no-print {
              display: none !important;
            }

            @page {
              margin: 10mm;
            }

          }
        `}
      </style>

      {/* HEADER */}

      <div
        className="
        flex
        justify-between
        items-center
        mb-6
        no-print
        "
      >

        <h1
          className="
          text-3xl
          font-bold
          "
        >
          Invoice
        </h1>

        <div
          className="
          flex
          gap-3
          "
        >

          <button
            onClick={printInvoice}
            className="
            px-5
            py-3
            bg-blue-500
            rounded-xl
            "
          >
            Print
          </button>

          <button
            onClick={() =>
              navigate(
                "/admin/invoices"
              )
            }
            className="
            px-5
            py-3
            bg-yellow-500
            text-black
            rounded-xl
            "
          >
            Back
          </button>

        </div>

      </div>

      {/* INVOICE */}

      <div
        id="invoice-print"
        className="
        bg-white
        text-black
        rounded-2xl
        p-8
        "
      >

        {/* COMPANY */}

        <div
          className="
          flex
          justify-between
          border-b
          pb-6
          mb-6
          "
        >

          <div>

            {invoice.logo && (
              <img
                src={`${process.env.REACT_APP_API_URL}/uploads/${invoice.logo}`}
                className="w-20 h-20 object-contain mb-3"
                alt=""
              />
            )}

            <h1 className="text-4xl font-bold">
              {invoice.company_name}
            </h1>

            <p>
              {invoice.company_address}
            </p>

            <p>
              Phone : {invoice.company_phone}
            </p>

            <p>
              Email : {invoice.company_email}
            </p>

            <p>
              GST : {invoice.gst_number}
            </p>

          </div>

          <div
            className="
            text-right
            "
          >

            <h2
              className="
              text-2xl
              font-bold
              "
            >
              TAX INVOICE
            </h2>

            <p>
              Invoice No:
              {" "}
              {
                invoice.invoice_no
              }
            </p>

            <p>
              Date:
              {" "}
              {
                new Date(invoice.created_at).toLocaleString()
              }
            </p>

            <p>
              Payment Status :
              <span className="font-semibold">
                {invoice.payment_status}
              </span>

              <br />

              Wallet :
              {invoice.payment_type}

              <br />

              Sold By :
              {invoice.sold_by_name}
            </p>

          </div>

        </div>

        {/* CUSTOMER */}

        <div
          className="
          mb-8
          "
        >

          <h3
            className="
            text-xl
            font-bold
            mb-3
            "
          >
            Bill To
          </h3>

          <p>
            <strong>
              {
                invoice.customer_name
              }
            </strong>
          </p>

          <p>
            {
              invoice.phone
            }
          </p>

          <p>
            {
              invoice.email
            }
          </p>

          <p>
            {
              invoice.address
            }
          </p>

        </div>

        {/* ITEMS */}

        <table
          className="
          w-full
          border
          border-gray-300
          "
        >

          <thead>

            <tr
              className="
              bg-gray-100
              "
            >

              <th className="p-3 border">
                #
              </th>

              <th className="p-3 border text-left">
                Product
              </th>

              <th className="p-3 border">
                Qty
              </th>

              <th className="p-3 border">
                Price
              </th>

              <th className="p-3 border">
                GST %
              </th>

              <th className="p-3 border">
                Amount
              </th>

            </tr>

          </thead>

          <tbody>

            {items.map(
              (
                item,
                index
              ) => (

                <tr
                  key={index}
                >

                  <td className="border p-3 text-center">
                    {index + 1}
                  </td>

                  <td className="border p-3">
                    {item.name}
                  </td>

                  <td className="border p-3 text-center">
                    {item.qty}
                  </td>

                  <td className="border p-3 text-center">
                    ₹
                    {
                      item.selling_price
                    }
                  </td>

                  <td className="border p-3 text-center">
                    {
                      item.gst_percent
                    }%
                  </td>

                  <td className="border p-3 text-center">
                    ₹
                    {
                      item.amount
                    }
                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

        {/* TOTALS */}

        <div
          className="
          flex
          justify-end
          mt-8
          "
        >

          <div
            className="
            w-80
            "
          >

            <div
              className="
              flex
              justify-between
              mb-2
              "
            >
              <span>
                Subtotal
              </span>

              <span>
                ₹
                {
                  invoice.subtotal
                }
              </span>
            </div>

            <div
              className="
              flex
              justify-between
              mb-2
              "
            >
              <span>
                GST
              </span>

              <span>
                ₹
                {
                  invoice.gst_total
                }
              </span>
            </div>

            <div
              className="
              flex
              justify-between
              mb-2
              "
            >
              <span>
                Discount
              </span>

              <span>
                ₹
                {
                  invoice.discount
                }
              </span>
            </div>

            <div
              className="
              flex
              justify-between
              text-2xl
              font-bold
              border-t
              border-b
              py-3
              "
            >
              <span>
                Grand Total
              </span>

              <span>
                ₹
                {
                  invoice.grand_total
                }
              </span>
            </div>

            <div
              className="
              flex
              justify-between
              my-2
              "
            >
              <span>
                Paid
              </span>

              <span>
                ₹
                {
                  invoice.paid_amount
                }
              </span>
            </div>

            <div
              className="
              flex
              justify-between
              mb-2
              "
            >
              <span>
                Due
              </span>

              <span>
                ₹
                {
                  invoice.remaining_amount
                }
              </span>
            </div>

          </div>

        </div>

        <p className="text-center mt-8 text-gray-600">
          {invoice.invoice_footer}
        </p>

        {/* FOOTER */}

        <div
          className="
          mt-16
          pt-8
          border-t
          "
        >

          <div
            className="
            flex
            justify-between
            "
          >

            <div>

              <p>
                Customer Signature
              </p>

            </div>

            <div>

              <p>
                Authorized Signatory
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ViewInvoice;